import {
  NAVIGATION_NEWS_ACTUALITY,
  NAVIGATION_NEWS_MOST_NEW,
  NAVIGATION_NEWS_REPORTAGE,
  NAVIGATION_NEWS_TESTS,
  NAVIGATION_NEWS_VIDEOS
} from './navigation'

export const subscriptionResponses = {
  201: {
    type: 'success',
    text: 'CARD_SUBSCRIPTION_MESSAGE_OK'
  },
  202: {
    type: 'success',
    text: 'CARD_SUBSCRIPTION_MESSAGE_OK',
    altText: 'CARD_SUBSCRIPTION_MESSAGE_VALIDATION_PENDING'
  },
  409: {
    type: 'info',
    text: 'CARD_SUBSCRIPTION_MESSAGE_EMAIL_EXISTS'
  },
  400: {
    type: 'error',
    text: 'CARD_SUBSCRIPTION_MESSAGE_INSERT_VALID_EMAIL'
  },
  424: {
    type: 'error',
    text: 'COMMON.SOMETHING_WENT_WRONG'
  },
  500: {
    type: 'error',
    text: 'COMMON.SOMETHING_WENT_WRONG'
  }
}

export const defaultSubscriptionResponse = subscriptionResponses['500']

export const NEWS_CATEGORIES_LABELS = {
  MAIN: 'portada',
  TESTS: 'pruebas',
  MOST_NEW: 'novedades',
  ACTUALITY: 'actualidad',
  VIDEOS: 'videos',
  REPORTAGES: 'reportajes'
}

export const newsCategories = [
  {
    id: 'news',
    label: NEWS_CATEGORIES_LABELS.MAIN,
    path: ''
  },
  {
    id: 'tests',
    label: NEWS_CATEGORIES_LABELS.TESTS,
    path: 'pruebas'
  },
  {
    id: 'newness',
    label: NEWS_CATEGORIES_LABELS.MOST_NEW,
    path: 'novedades'
  },
  {
    id: 'actuality',
    label: NEWS_CATEGORIES_LABELS.ACTUALITY,
    path: 'actualidad'
  },
  {
    id: 'videos',
    label: NEWS_CATEGORIES_LABELS.VIDEOS,
    path: 'videos'
  },
  {
    id: 'reportages',
    label: NEWS_CATEGORIES_LABELS.REPORTAGES,
    path: 'reportajes'
  }
]

export const categoriesUrls = newsCategories.map(category => category.path)

export const SPECIAL_BRANDS = []

export const MAKES_WITH_HYPHENS = []

/**
 * @exports boolean condition used in getFormattedTagNewsSearchUseCase
 */

export const NEED_SPECIAL_FORMAT_TAG_TO_URL = false

export const ARTICLE_COMMENTS_ANCHOR = '#ctrl_comments'
export const HAS_MOBILE_COMMENTS_PAGE_ENABLED = false
export const NEWSLETTER_SIDEBAR_ENABLED = true
export const NEWSLETTER_BANNER_ENABLED = false
export const NEWSLETTER_BODY_ENABLED = false

export const BREADCRUMBS_ROOT_LITERAL = 'BREADCRUMB_NEWS_LABEL_MOTOS'
export const CATEGORIES_LISTING_URLS = {
  [NEWS_CATEGORIES_LABELS.ACTUALITY]: NAVIGATION_NEWS_ACTUALITY.url,
  [NEWS_CATEGORIES_LABELS.MOST_NEW]: NAVIGATION_NEWS_MOST_NEW.url,
  [NEWS_CATEGORIES_LABELS.TESTS]: NAVIGATION_NEWS_TESTS.url,
  [NEWS_CATEGORIES_LABELS.REPORTAGES]: NAVIGATION_NEWS_REPORTAGE.url,
  [NEWS_CATEGORIES_LABELS.VIDEOS]: NAVIGATION_NEWS_VIDEOS.url
}
export const MAX_RELATED_ADS = 4
export const HAS_RATING_ENABLED = false
export const SAVED_NEWS_EMPTY_CASE_IMAGE = 'images/illustrations/save-news-for-later-empty-case-motos.svg'
export const ARTICLE_CARD_IMAGE_WIDTH_L = 864
export const ARTICLE_CARD_IMAGE_WIDTH_M = 432
export const ARTICLE_CARD_IMAGE_WIDTH_S = 300
export const ARTICLE_BODY_IMAGE_WIDTH = 900
